import merge from 'lodash/merge';
import App from './views/App.svelte';
import DocumentService from './services/document.service';
import ServiceProvider from './services/service.provider';
import DataProvider from './services/data.provider';
import AppList from './views/AppList.svelte';
class SearchApp {
    constructor(options) {
        this.options = options;
    }
    mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.options);
            const searchService = new DocumentService(this.dataProvider);
            this.serviceProvider = new ServiceProvider(searchService);
            this.createInstance();
        }
        catch (e) {
            console.log(e);
        }
    }
    createInstance() {
        new App({
            target: this.targetFilterElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
        new AppList({
            target: this.targetElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
    }
    get targetElement() {
        const { el } = this.options;
        const element = document.querySelector(el);
        if (null === element) {
            throw new Error("The container for displaying Documents does not exist");
        }
        return element;
    }
    get targetFilterElement() {
        const { filterEl } = this.options;
        const element = document.querySelector(filterEl);
        if (null === element) {
            throw new Error("The container for displaying Documents filter does not exist");
        }
        return element;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            el: null,
            placeholder: null,
            cta: null,
            reset: null,
            submitTarget: null,
            structureKeys: null,
            groupId: null,
            fileEntryTypeId: null,
            showSiteUrl: null,
            categories: null,
            documentFolders: null,
        }, this.options);
    }
}
const filter = document.getElementById('filter-documents-module');
const container = document.getElementById('list-documents-module');
if (container && filter) {
    const structureKeys = container.getAttribute("data-structure-keys"); //36583|36568
    const groupId = container.getAttribute('data-group-id') || null;
    const fileEntryTypeId = filter.getAttribute('data-file-entry-type-id') || null; //168932
    const showSiteUrl = filter.getAttribute("data-show-site-url") || "false";
    const cta = filter.getAttribute("data-cta") || "Filtrovat";
    const reset = filter.getAttribute("data-ctaReset") || "Vymazat filtr";
    const placeholder = filter.getAttribute("data-placeholder") || "Vyhledat...";
    const categories = filter.getAttribute("data-categories");
    const documentFolders = filter.getAttribute("data-document-folders");
    const searchApp = new SearchApp({
        structureKeys,
        groupId,
        fileEntryTypeId,
        showSiteUrl,
        filterEl: '#filter-documents-module',
        el: "#list-documents-module",
        cta,
        reset,
        placeholder,
        categories,
        documentFolders,
    });
    searchApp.mount();
}
